export const getTreeDataPath = row => row.hierarchy;
